<template>
  <div
    id="collectionWronglistFilter"
    :class="isShowFirstFilterPanelContent ? 'modal-content' : 'd-none'"
  >
    <div class="modal-header justify-content-between align-items-center bg-light px-2 py-1">
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="close">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>
      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>

    <div class="modal-body p-0">
      <div
        class="d-flex justify-content-around align-items-center p-4 text-white text-center"
        :class="exerciseType === 2 ? 'bg-warning' : 'bg-danger'"
      >
        <div>
          <h3 class="mb-0 font-weight-normal">{{ allQuestionCount }}</h3>
          <p class="mb-0 small" v-if="exerciseType === 2">累计收藏数</p>
          <p class="mb-0 small" v-if="exerciseType === 3">累计错题数</p>
        </div>
        <div>
          <h3 class="mb-0 font-weight-normal">{{ allBookCount }}</h3>
          <p class="mb-0 small">书</p>
        </div>
        <div>
          <h3 class="mb-0 font-weight-normal">{{ allReadingCount }}</h3>
          <p class="mb-0 small">章节</p>
        </div>
        <div>
          <h3 class="mb-0 font-weight-normal">{{ allSubjectCount }}</h3>
          <p class="mb-0 small">课题</p>
        </div>

        <!-- <i class="pz-icon icon-chevron-right"></i> -->
      </div>

      <div class="p-3">
        <form class="p-4">
          <div class="form-group">
            <label for="BookSelect1">学科</label>
            <select
              class="form-control form-control-lg"
              v-model="bookId"
              @change="changeBook(bookId)"
              id="BookSelect1"
            >
              <option
                v-for="(item, idx) in BookTreeList"
                :value="item.bookId"
                :key="`book--tree-filter-${idx}`"
              >
                {{ item.bookName }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ReadingSelect1">章节</label>
            <select
              v-model="readingId"
              @change="changeReading(readingId)"
              class="form-control form-control-lg"
              id="ReadingSelect1"
            >
              <option
                v-for="(item, idx) in readings"
                :value="item.readingId"
                :key="`book-tree--filter-reading-${idx}`"
              >
                {{ item.readingName }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="SubjectSelect1">课题</label>
            <select
              v-model="subjectId"
              @change="changeSubject(subjectId)"
              class="form-control form-control-lg"
              id="SubjectSelect1"
            >
              <option
                v-for="(item, idx) in subjects"
                :value="item.subjectId"
                :key="`book-tree--filter-subject-${idx}`"
              >
                {{ item.subjectName }}
              </option>
            </select>
          </div>
          <!-- <div class="form-group">
            <label for="BulletSelect1">知识点</label>
            <select
              v-model="bulletId"
              @change="changeBullet(bulletId)"
              class="form-control form-control-lg"
              id="BulletSelect1"
            >
              <option
                v-for="(item, idx) in bullets"
                :value="item.bulletId"
                :key="`book-tree--filter-bullet-${idx}`"
              >{{ item.bulletName }}</option>
            </select>
          </div>-->

          <div class="form-group" v-if="exerciseType === 3">
            <label for="SubjectSelect1">错题次数</label>
            <select v-model="count" class="form-control form-control-lg" id="countSelect1">
              <option
                v-for="(item, idx) in l_wrongCountList"
                :value="item.key"
                :key="`book-wrong--filter-count-${idx}`"
              >
                {{ item.value }}
              </option>
            </select>
          </div>
        </form>
        <div class="p-4" v-if="Groups.length > 0">
          <dl class="row mb-5" v-for="(group, groupIdx) in Groups" :key="`group--key-${groupIdx}`">
            <dt class="col-12 mb-2">{{ group.groupName }}</dt>
            <template v-for="(type, typeIdx) in group.types">
              <dd class="col-6" v-if="type.questionCount" :key="`group-key--${typeIdx}`">
                <button
                  type="button"
                  @click="selectType(type)"
                  class="btn btn-light btn-block d-flex justify-content-between btn-filter-active"
                  :class="{ active: type.isSelected }"
                >
                  {{ type.typeName }}
                  <i class="pz-icon icon-check text-success"></i>
                  <!-- <span class="ml-auto">{{ type.questionCount }}</span> -->
                </button>
              </dd>
            </template>
          </dl>
        </div>
      </div>
    </div>

    <div class="modal-footer bg-light justify-content-between">
      <span class="text-secondary text-dark">共{{ selectedQuestionCount }}道题</span>
      <div id="containerFooterRight">
        <div id="switchWrongList" class="custom-control custom-switch" v-if="exerciseType === 3">
          <input
            type="checkbox"
            id="customSwitch1"
            v-model="autoRemoveWronglist"
            class="custom-control-input"
          />
          <label for="customSwitch1" class="custom-control-label">答对后自动移除错题</label>
        </div>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!selectedQuestionCount"
          @click="doFilter"
        >
          开始
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
//import $ from 'jquery';
import { findIndex, groupBy, /* isEmpty, */ filter, flatten } from 'lodash';
//import { isEqual } from 'lodash';

export default {
  name: 'CollectionWronglistFilter',

  props: {
    isFullscreen: Boolean,
    onResizeModal: Function,
    exerciseType: {
      type: Number,
      default: () => '',
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    title: String,

    bookTreeList: {
      type: Array,
      default: () => [],
    },

    typeQuestionList4mycollection: {
      type: Array,
      default: () => [],
    },

    mywrongCountList: {
      type: Array,
      default: () => [],
    },

    onGetQuestions: {
      type: Function,
      default: () => {},
    },

    isShowFirstFilterPanelContent: {
      type: Boolean,
      default: () => false,
    },

    setIsShowFirstFilterPanelContent: {
      type: Function,
      default: () => {},
    },

    isShowQuestionPanel: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      bookIdx: 0,
      readingIdx: 0,
      subjectIdx: 0,
      //bulletIdx: 0,
      selectedTypeArr: [],
      count: -1,
      l_bookTreeList: [],
      allQuestionCount: 0,
      allBookCount: 0,
      allReadingCount: 0,
      allSubjectCount: 0,
      l_wrongCountList: [],
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    autoRemoveWronglist: {
      get: function () {
        return this.userInfo.profile.autoRemoveWronglist;
      },
      set: function (autoRemoveWronglist) {
        this.updateProfile({ autoRemoveWronglist });
      },
    },

    selectedBooks: function () {
      return filter(
        this.BookTreeList,
        (book) =>
          (-1 === this.bookId && -1 !== book.bookId) ||
          (-1 !== this.bookId && this.bookId === book.bookId)
      );
    },

    selectedReadings: function () {
      const readings = flatten(this.selectedBooks.map((book) => book.readings));
      return filter(
        readings,
        (reading) =>
          (-1 === this.readingId && -1 !== reading.readingId) ||
          (-1 !== this.readingId && this.readingId === reading.readingId)
      );
    },

    selectedSubjects: function () {
      const subjects = flatten(this.selectedReadings.map((reading) => reading.subjects));
      return filter(
        subjects,
        (subject) =>
          (-1 === this.subjectId && -1 !== subject.subjectId) ||
          (-1 !== this.subjectId && this.subjectId === subject.subjectId)
      );
    },

    selectedQuestionCount: function () {
      return this.selectedSubjects.reduce((accumulator, item) => {
        let k = 'subjectQuesttionCount';
        if (3 === this.exerciseType && -1 !== this.count) {
          k = `questionWrongCount${this.count}`;
        }
        return accumulator + item[k];
      }, 0);
    },

    BookTreeList: function () {
      const item = {
        bookId: -1,
        bookName: '全部',
        readings: [
          {
            readingId: -1,
            readingName: '全部',
            subjects: [
              {
                subjectId: -1,
                subjectName: '全部',
                /* bullets: [
                  {
                    bulletId: -1,
                    bulletName: '全部',
                  },
                ], */
              },
            ],
          },
        ],
      };
      const arr = this.l_bookTreeList;
      if (arr && arr.length > 0) {
        return [item, ...arr];
      } else {
        return [item];
      }
    },

    TypeList: function () {
      if (2 === this.exerciseType) {
        return this.typeQuestionList4mycollection;
      } else {
        return [];
      }
    },

    Groups: {
      get: function () {
        const obj = groupBy(this.TypeList, 'group');
        let arr = [];
        for (let key in obj) {
          arr.push({
            groupId: key,
            groupName: obj[key][0].groupName,
            types: obj[key].map((v) => {
              return {
                ...v,
                isSelected:
                  findIndex(this.selectedTypeArr, {
                    group: v.group,
                    typeValue: v.typeValue,
                  }) !== -1
                    ? true
                    : false,
              };
            }),
          });
        }
        // console.log(arr);
        return arr;
      },
      set: function (attr) {
        this.selectedTypeArr = attr;
      },
    },

    bookId: {
      get: function () {
        return this.BookTreeList && this.BookTreeList.length > 0 && this.bookIdx >= 0
          ? this.BookTreeList[this.bookIdx].bookId
          : -1;
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.BookTreeList, { bookId });
      },
    },

    readingId: {
      get: function () {
        return this.readings && this.readings && this.readings.length > 0 && this.readingIdx >= 0
          ? this.readings[this.readingIdx].readingId
          : -1;
      },
      set: function (readingId) {
        this.readingIdx = findIndex(this.readings, { readingId });
      },
    },

    readings: {
      get: function () {
        if (this.BookTreeList && this.bookIdx > 0) {
          return [
            {
              readingId: -1,
              readingName: '全部',
            },
            ...this.BookTreeList[this.bookIdx].readings,
          ];
        } else {
          return [
            {
              readingId: -1,
              readingName: '全部',
              subjects: [
                {
                  subjectId: -1,
                  subjectName: '全部',
                  /* bullets: [
                    {
                      bulletId: -1,
                      bulletName: '全部',
                    },
                  ], */
                },
              ],
            },
          ];
        }
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.BookTreeList, { bookId });
      },
    },

    subjectId: {
      get: function () {
        return this.subjects && this.subjects.length > 0 && this.subjectIdx >= 0
          ? this.subjects[this.subjectIdx].subjectId
          : -1;
      },
      set: function (subjectId) {
        this.subjectIdx = findIndex(this.subjects, { subjectId });
      },
    },

    subjects: {
      get: function () {
        if (this.readings && this.readingIdx > 0) {
          return [
            {
              subjectId: -1,
              subjectName: '全部',
            },
            ...this.readings[this.readingIdx].subjects,
          ];
        } else {
          return [
            {
              subjectId: -1,
              subjectName: '全部',
              /* bullets: [
                {
                  bulletId: -1,
                  bulletName: '全部',
                },
              ], */
            },
          ];
        }
      },
      set: function (readingId) {
        this.readingIdx = findIndex(this.readings, { readingId });
      },
    },

    //bulletId: {
    //  get: function() {
    //    return this.bullets &&
    //      this.bullets &&
    //      this.bullets.length > 0 &&
    //      this.bulletIdx >= 0
    //      ? this.bullets[this.bulletIdx].bulletId
    //      : -1;
    //  },
    //  set: function(bulletId) {
    //    this.bulletIdx = findIndex(this.bullets, { bulletId });
    //  },
    //},

    //bullets: {
    //  get: function() {
    //    if (this.subjects && this.subjectIdx > 0) {
    //      return [
    //        {
    //          bulletId: -1,
    //          bulletName: '全部',
    //          // questionCount: this.BookTreeList[this.bookIdx].questionCount,
    //        },
    //        ...this.subjects[this.subjectIdx].bullets,
    //      ];
    //    } else {
    //      return [
    //        {
    //          bulletId: -1,
    //          bulletName: '全部',
    //        },
    //      ];
    //    }
    //  },
    //  set: function(subjectId) {
    //    this.subjectIdx = findIndex(this.subjects, { subjectId });
    //  },
    //},
  },

  // updated() {
  //   console.log(this.PzFilterData.studentFilter);
  // },

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    close() {
      if (this.isShowQuestionPanel) {
        this.setIsShowFirstFilterPanelContent(false);
      } else {
        this.onClose();
      }
    },

    async doFilter() {
      this.setIsShowFirstFilterPanelContent(false);
      //$('#collectionWronglistFilter').modal('hide');
      // if (this.filterFlag) {
      let payload = {
        practiceType: this.exerciseType,
        bookId: this.bookId,
        readingId: this.readingId,
        subjectId: this.subjectId,
        //bulletId: this.bulletId,
        attribute: this.selectedTypeArr,
        inFilter: false,
      };
      if (3 === this.exerciseType) {
        payload = {
          ...payload,
          wrongCount: this.count,
        };
      }
      await this.onGetQuestions(payload);
      // this.filterFlag = false;
      // }
    },

    changeBook(bookId) {
      // this.filterFlag = true;
      this.bookId = bookId;
      this.readingId = this.readings[0].readingId;
      this.subjectId = this.subjects[0].subjectId;
      //this.bulletId = this.bullets[0].bulletId;
    },

    changeReading(readingId) {
      // this.filterFlag = true;
      this.readingId = readingId;
      this.subjectId = this.subjects[0].subjectId;
      //this.bulletId = this.bullets[0].bulletId;
    },

    changeSubject(subjectId) {
      // this.filterFlag = true;
      // this.bookId = bookId;
      this.subjectId = subjectId;
      // this.subjectId = this.readings[0].subjects[0].subjectId;
      //this.bulletId = this.bullets[0].bulletId;
    },

    //changeBullet(bulletId) {
    //  // this.filterFlag = true;
    //  this.bulletId = bulletId;
    //},

    selectType(type) {
      // this.filterFlag = true;
      if (!type.isSelected) {
        this.selectedTypeArr.push({
          group: type.group,
          typeValue: type.typeValue,
        });
      } else {
        const idx = findIndex(this.selectedTypeArr, {
          group: type.group,
          typeValue: type.typeValue,
        });
        this.selectedTypeArr.splice(idx, 1);
      }
    },
  },

  created() {
    this.l_bookTreeList = this.bookTreeList;
    this.l_wrongCountList = [
      {
        key: -1,
        value: '全部',
      },
      ...this.mywrongCountList,
    ];
    this.allBookCount = this.selectedBooks.length;
    this.allReadingCount = this.selectedReadings.length;
    this.allSubjectCount = this.selectedSubjects.length;
    this.allQuestionCount = this.selectedQuestionCount;
  },
};
</script>
<style lang="scss" scoped>
#containerFooterRight {
  display: flex;
  align-items: center;
}
#switchWrongList {
  padding-right: 1rem;
}
</style>
